import { createGlobalStyle } from 'styled-components'
import * as theme from '.'

export const GlobalStyle = createGlobalStyle`
   // Scope styling to App and Storybook wrappers

   .App,
   .sb-show-main {
      height: 100%;
      font-size: ${theme.fontBase.size};
      color: ${theme.color.text};
      font-family: ${theme.fontBase.regular};
      line-height: ${theme.fontBase.lineHeight};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-text-size-adjust: 100%;

      *,
      *:before,
      *:after {
         box-sizing: border-box;
      }

      a img {
         border: 0;
      }
   
      a {
         color: ${theme.color.link};
         text-decoration: none;
      }
   }   
`
